import React from "react";
import styled from "styled-components";
import { IconController } from "../../Scripts/ImgController";
import Skeleton from "react-loading-skeleton";
const Wrapper = styled.div`
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;
const WalletCard = ({
  gradientColor,
  numbers,
  numbersColor,
  desc,
  descColor,
  icon,
  loaded,
}) => {
  return (
    <Wrapper
      className="w-full rounded-2xl p-4 md:p-6 shadow-CK"
      style={{
        background: `linear-gradient(270deg, #${gradientColor}4d 0.09%, #${gradientColor}0d 99.91%)`,
      }}
    >
      <div className="flex flex-col gap-3">
        <div className="flex flex-row justify-between items-center gap-2">
          {loaded ? (
            <h2
              className="font-bold text-2xl lg:text-3xl break-all"
              style={{ color: `#${numbersColor}` }}
            >
              {numbers}₮
            </h2>
          ) : (
            <div className="w-2/3 h-full opacity-20">
              <Skeleton
                baseColor={"#" + numbersColor}
                highlightColor={"#" + descColor}
                height="36px"
              />
            </div>
          )}
          <IconController src={icon} className="h-10 w-10" />
        </div>
        <h4 className="font-bold text-xs" style={{ color: `#${descColor}` }}>
          {desc}
        </h4>
      </div>
    </Wrapper>
  );
};

export default WalletCard;
